import { Component, OnInit } from '@angular/core';
import { AuthService } from 'libs/pnp-services/src/lib/auth/auth.service';
import { LoginService } from '../../core/services/login.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@pn-plus/pnp-environment';


@Component({
    selector: 'pnpl-login-layout',
    templateUrl: './login-layout.component.html',
    styleUrls: ['./login-layout.component.scss'],
})
export class LoginLayoutComponent implements OnInit {
    url = 'https://www.patientnow.com/apps/apps_login-slider/';
    urlSafe: SafeResourceUrl;
  
    constructor(
        public authService: AuthService,
        public loginService: LoginService,
        private sanitizer: DomSanitizer,
    ) {
    }

    ngOnInit() {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

        // this.authService.resetLogin();
        this.loginService.getRecentLogins();
    }
}
